<template>
  <v-autocomplete
    label="Guru"
    :value="value"
    @change="handleChange"
    placeholder="Pilih Guru"
    :items="guru"
  >
  </v-autocomplete>
</template>

<script>
export default {
  data() {
    return {
      guru: [],
    };
  },
  mounted() {
    this.getData();
  },
  props: ["value"],
  emits: ["change"],
  methods: {
    getData() {
      this.$root.app.http.get("/api/guru").then((res) => {
        res.data.forEach((item) => {
          this.guru.push({
            value: item.id,
            text: item.nama,
          });
        });
      });
    },
    handleChange(val) {
      this.$emit("change", val);
    },
  },
};
</script>
